/**
 * Shallow-merge top-level locale namespaces; deep-merge `common` only.
 * Fall-detect keys (activity, alarm, cfg, …) are new; `common` overlaps with MC.
 */
export function mergeFallDetectLocale(base, fall) {
  if (!fall || typeof fall !== 'object') return base
  const out = { ...base }
  for (const [key, value] of Object.entries(fall)) {
    if (key === 'common' && value && typeof value === 'object' && out.common) {
      out.common = { ...out.common, ...value }
    } else {
      out[key] = value
    }
  }
  return out
}
